import { render } from "./ViewAddPreview.vue?vue&type=template&id=0c52f293"
import script from "./ViewAddPreview.vue?vue&type=script&lang=js"
export * from "./ViewAddPreview.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/360pt/V3/v2026.13.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__